import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { APP_BASE_HREF, LocationStrategy, HashLocationStrategy, } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';


import { AppComponent } from './app.component';
import { QuestionComponent } from './question/question.component';

import { QuestionService } from './question.service';
import { GpioService } from './gpio.service';
import { CountdownComponent } from './countdown/countdown.component';
import { DebugModule } from './debug/debug.module';
import { ConsoleService } from './console.service';
import { DetailsComponent } from './details/details.component';


@NgModule({
    declarations: [
        AppComponent,
        QuestionComponent,
        CountdownComponent,
        DetailsComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        DebugModule
    ],
    providers: [
        ConsoleService,
        QuestionService,
        GpioService,
        {
          provide: APP_BASE_HREF,
          useValue: '/'
        },
        {
          provide: LocationStrategy,
          useClass: HashLocationStrategy
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
